import React, { useEffect } from "react";
import "./immobilienvermittlung.scss";
import ImmobilienvermittlungImage from "../../../assets/images/immobilienvermittlung.png";
import ImmobilienvermittlungRightContent from "./immobilienvermittlungRightContent";
import { NavLink } from "react-router-dom";
export default function Immobilienvermittlung() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <div className="immobilienvermittlung-section-alignment">
        <div className="left-side-content-alignment">
          <div className="grid">
            <div className="grid-items">
              <div className="text-grid animate__fadeInLeft animate__animated">
                <div className="text-grid-items">
                  <div className="divider"></div>
                </div>
                <div className="text-grid-items">
                  <h1 className="">Immobilienvermittlung erfolgsabhängig</h1>
                </div>
              </div>
              <p className="animate__fadeInUp animate__animated">
                Sie wollen vermieten oder verkaufen und brauchen dabei
                Unterstützung? Wir kümmern uns gern um Ihre Immobilie - vom
                Inserat bis zur Durchführung der Besichtigungen.
              </p>
              <div className="outline-primary-button">
                <NavLink to="/kontakt">
                  <button className="animate__fadeInUp animate__animated">
                    Kontakt aufnehmen
                  </button>
                </NavLink>
              </div>
            </div>
            <div className="grid-items">
              <div className="image-style">
                <NavLink to="/kontakt">
                  <img
                    className="animate__backInUp animate__animated"
                    src={ImmobilienvermittlungImage}
                    alt="ImmobilienvermittlungImage"
                  />
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ImmobilienvermittlungRightContent />
    </>
  );
}
